<template>
  <div class="flex flex-row items-center device-wrap gap-3 p-3" @click="$emit('click')">
    <div style="flex:1.2" class="brand-icon">
      <van-image :src="device.brandPicture" width="100%" class="p-2.5" fit="cover"/>
    </div>
    <div class="flex-1 device-usage-history main-color">
      <div style="margin-bottom:10px;font-size:14px;">Usage History</div>
      <div v-for="(item,index) in device.usageTime" :key="index">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyDeviceItem",
  props: {
    device: {
      type: Object,
      require:true
    }
  }
};
</script>

<style scoped lang="less">
.brand-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.device-wrap {
  background: white;
  margin-left:16px;
  margin-right:16px;
  border-radius: 10px;
}
.device-usage-history {
  min-height:95px;
  text-align: start;
  padding:10px 16px;
  font-size:10px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background: #E8E8E8;
  font-weight: lighter;



}
</style>